// extracted by mini-css-extract-plugin
export default {"darkmode":"darkmode_darkmode__gHY3-","img":"darkmode_img__yT+sc","hover":"darkmode_hover__SQxDn"};